<!--
Author: erba-28
Create Time: 2020-04-22 11:21:25
Description: 网格图坐标创建器
-->
<template>
  <div class="com-graph-coords-creator">
    <el-input v-model="mValue" :disabled="disabled || dialog" @focus.stop.prevent="open"></el-input>
    <el-dialog
      title="设置楼栋坐标"
      v-dialogDrag
      :visible.sync="dialog"
      width="860px"
      :close-on-click-modal="false"
      :append-to-body	="true"
      :modal="false"
    >
        <el-row >
          <el-col>
            <el-form
              ref="form"
              label-width="100px"
              :inline="false"
              style="padding-top: 10px;"
              label-suffix=":"
              >
              <el-col :span="12">
                <el-form-item label="区域形状">
                  <el-select
                    v-model="mShape"
                    clearable
                    placeholder="请选择"
                    :disabled="disabled || !isCreating"
                    @change="handleShapeChange"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in shapeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.status === 0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="楼栋坐标">
                  <el-input v-model="mAlt" :title="mAlt" :disabled="disabled" width="100%"></el-input>
                </el-form-item>
              </el-col>
          <!-- <el-col :span="16">
            <el-input :value="coords.join(' ')" :title="coords.join(' ')" :disabled="true"></el-input>
          </el-col> -->
              <el-col :span="24">
                <div style="position: relative; height: calc(80vh - 80px - 1em - 64px - 60px - 2em); overflow: auto;">
                  <img
                      ref="img"
                      v-show="imgPath"
                      :src="imgPath ?  imgPath : ''"
                      class="img"
                      @load="handleResize4Img"
                      @error="handleImgError"
                      width="100%"
                      style="position: absolute;top: 0;left: 0;"
                    />
                    <svg
                      :width="imgWidth"
                      :height="imgHeight"
                      :viewBox="[0, 0, imgNaturalWidth, imgNaturalHeight].join(' ')"
                      style="position: absolute;top: 0;left: 0;"
                      @click.stop="handleImgClick"
                    >
                      <rect v-show="rectObj.show" v-bind="rectObj.attrs" />
                      <circle v-show="circleObj.show" v-bind="circleObj.attrs" />
                      <polygon v-show="polygonObj.show" v-bind="polygonObj.attrs" />
                    </svg>
                </div>
              </el-col>

            </el-form>
          </el-col>
        </el-row>
        <span slot="footer">
          <el-button v-show="!isCreating" :disabled="disabled" @click="createCoords" size="medium" type="primary">创建坐标</el-button>
          <el-button v-show="!isCreating" :disabled="disabled" @click="back" size="medium" icon="el-icon-back">返回</el-button>
          <el-button v-show="isCreating" :disabled="disabled" @click="confirm" size="medium" type="primary" icon="el-icon-document">确定</el-button>
          <el-button v-show="isCreating" :disabled="disabled" @click="cancel" size="medium" icon="el-icon-back">返回</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "graphCoordsCreator",
  props: {
    value: {
      type: String,
      default: () => ""
    },
    shape: {
      type: String,
      default: () => "rect" // rect||circle||polygon
    },
    imgPath: {
      type: String,
      default: () => ""
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    alt: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      shapeOptions: [
        { value: "rect", label: "矩形" },
        { value: "circle", label: "圆形" },
        { value: "polygon", label: "多边形" }
      ],
      imgNaturalWidth: 1,
      imgNaturalHeight: 1,
      imgWidth: 1,
      imgHeight: 1,
      isImgLoadedSuccessfully: false,

      dialog: false,

      coords: [],
      isCreating: false
    };
  },
  computed: {
    mShape: {
      get() {
        return this.shape;
      },
      set(val) {
        this.$emit("update:shape", val);
      }
    },
    mValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    mAlt: {
      get() {
        return this.alt;
      },
      set(val) {
        this.$emit("update:alt", val);
      }
    },
    imgScale() {
      return Math.max(1, this.imgWidth) / Math.max(1, this.imgNaturalWidth);
    },
    rectObj() {
      let coords = this.coords;
      if (this.mShape !== "rect" || coords.length !== 4) {
        return {
          show: false,
          attrs: {}
        };
      }
      let [a, b, c, d] = coords;
      let attrs = {
        x: a,
        y: b,
        width: Math.max(0, c - a),
        height: Math.max(0, d - b),
        fill: "none",
        stroke: "lightgray"
      };
      return {
        show: true,
        attrs
      };
    },
    circleObj() {
      let coords = this.coords;
      if (this.mShape !== "circle" || coords.length !== 4) {
        return {
          show: false,
          attrs: {}
        };
      }
      let [a, b, c, d] = coords;
      let attrs = {
        cx: a,
        cy: b,
        r: Math.sqrt((c - a) ** 2 + (d - b) ** 2),
        fill: "none",
        stroke: "lightgray"
      };
      return {
        show: true,
        attrs
      };
    },
    polygonObj() {
      let coords = this.coords;
      if (this.mShape !== "polygon" || coords.length < 3) {
        return {
          show: false,
          attrs: {}
        };
      }
      let attrs = {
        points: coords.join(" "),
        fill: "none",
        stroke: "lightgray"
      };
      return {
        show: true,
        attrs
      };
    }
  },
  methods: {
    handleResize4Img() {
      setTimeout(() => {
        let elImg = this.$refs.img || {};
        this.imgNaturalWidth = elImg.naturalWidth;
        this.imgNaturalHeight = elImg.naturalHeight;
        this.imgWidth = elImg.clientWidth;
        this.imgHeight = elImg.clientHeight;
      }, 100);
      this.isImgLoadedSuccessfully = true;
    },
    handleImgError($event) {
      this.isImgLoadedSuccessfully = false;
    },
    handleImgClick($event) {
      if (this.isCreating) {
        let x = parseInt($event.offsetX / this.imgScale);
        let y = parseInt($event.offsetY / this.imgScale);
        if (this.mShape === "polygon") {
          this.coords.push([x, y].join(","));
        } else {
          this.coords.push(...[x, y]);
        }

        this.autoConfirm();
      }
    },
    open() {
      this.dialog = true;
      this.coords = (this.mValue || "").split(" ");
    },
    close() {
      this.dialog = false;
    },
    handleShapeChange(val) {
      this.$message.warning(
        `开始创建${
          (this.shapeOptions.find(o => o.value === val) || {}).label
        }坐标`
      );
      this.coords = [];
    },
    createCoords() {
      this.isCreating = true;
      this.coords = [];
    },
    back() {
      this.isCreating = false;
      this.coords = [];
      this.dialog = false;
    },
    cancel() {
      this.isCreating = false;
      this.coords = (this.mValue || "").split(" ");
    },
    autoConfirm(manual = false) {
      if (!this.isCreating) {
        return;
      }
      switch (this.mShape) {
        case "rect":
          if (this.coords.length < 4) {
            return;
          }
          break;
        case "circle":
          if (this.coords.length < 4) {
            return;
          }
          break;
        case "polygon":
          if (!manual) {
            return;
          }
          break;
        default:
          // this.$message.warning(`未知的形状: ${this.mShape}`);
          return;
      }
      this.isCreating = false;
      this.mValue = this.coords.join(" ");
      this.$message.warning(
        `创建${
          (this.shapeOptions.find(o => o.value === this.mShape) || {}).label
        }坐标 成功！`
      );
    },
    confirm() {
      this.autoConfirm(true);
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize4Img);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize4Img);
  }
};
</script>

<style scoped lang="less">
// .com-graph-coords-creator {}

.dialog-content {
  box-sizing: border-box;
  padding: 1em;
  overflow: auto;
}

.img {
  max-width: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/graphCoordsCreator/graphCoordsCreator.vue